package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.restaurant_tab.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.printer_location.PrinterLocation
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.restaurant_data.GetRestaurant
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.MediumContentTitle

@Composable
fun PrinterLocations(
    printerLocation: List<PrinterLocation?>?,
    restaurantData: GetRestaurant?,
    printerLocationArray: ArrayList<Boolean?>?,
    updatePrinterLocation: (List<Boolean?>?) -> Unit,
) {
    MediumContentTitle(
        title =  Strings.current().printerLocations,
    )

    Column(
        modifier = Modifier
            .margin(left = Dimen.normalPadding)
    ){
        printerLocation?.forEach {
            if (it != null) {
                CheckboxComponent(
                    modifier = Modifier.margin(top = Dimen.smallPadding),
                    checkStatus = restaurantData?.printerLocations?.get(it.dbIndex) ?: false,
                    title = it.value,
                    onChecked = {
                        printerLocationArray?.set(it.dbIndex, true)
                        updatePrinterLocation(printerLocationArray)
                    },
                    onUnChecked = {
                        printerLocationArray?.set(it.dbIndex, false)
                        updatePrinterLocation(printerLocationArray)
                    },
                )
            }
        }
    }
}